import React from 'react'
import { withRouter } from 'react-router'
import { Form, Button, Modal } from 'semantic-ui-react'
import { CommonField } from '@bsd/dashboard-toolkit/components/forms'
import { InputField, TextAreaField } from '@bsd/dashboard-toolkit/components/forms/fields'
import AbsoluteDiv from '@bsd/dashboard-toolkit/components/AbsoluteDiv'
import { fetchAPI } from '@bsd/dashboard-toolkit/utils'

import { DEFAULT_LOCALE, LOCALES } from '../constants'
import GeoObjectImagesField from './fields/GeoObjectImagesField'
import LocalizationField from './fields/LocalizationField'
import CoordinatesField from './fields/CoordinatesField'
import CountriesDropdown from './fields/CountriesDropdown'
import DatetimeField from './fields/DatetimeField'
import FileField from './fields/FileField'


const GeoObjectLocaleForm = ({ data, onChange }) =>
  <>
    <Form.Field>
      <label>Название</label>
      <InputField value={data.name} onChange={onChange('name')}/>
    </Form.Field>
    <Form.Field>
      <label>Описание</label>
      <TextAreaField value={data.description} onChange={onChange('description')}/>
    </Form.Field>
  </>

const ObjectDeleteModal = ({ onDelete, onCancel, geoObject }) =>
  <Modal open dimmer='inverted'>
    <Modal.Header>Удаление объекта</Modal.Header>
    <Modal.Content>
      Действительно удалить объект {geoObject.locales[DEFAULT_LOCALE].name}?
    </Modal.Content>
    <Modal.Actions>
      <Button basic icon='delete' content='Отмена' onClick={onCancel}/>
      <Button basic icon='trash' color='red' content='Удалить' onClick={onDelete}/>
    </Modal.Actions>
  </Modal>

class GeoObjectForm extends React.Component {

  coordinatesField = React.createRef()

  constructor(props) {
    super(props)
    this.state = this.initState()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.geoObjectId !== this.props.geoObjectId) {
      this.setState(this.initState(), () => {
        this.coordinatesField.current.reset()
      })
    }
  }

  initState = () => {
    const data = this.props.initialData || {}
    let locales = { ...data.locales }
    LOCALES.forEach(locale => {
      if (!locales[locale.code]) {
        locales[locale.code] = { name: '', description: '' }
      }
    })
    return {
      data: {
        coordinates: data.coordinates || { lat: 54.85767119736805, lon: 83.10849216766655 },
        images: data.images || [],
        available_since: data.available_since || '',
        locales,
        model: data.model || null,
        model_ios: data.model_ios || null,
        country: data.country || null,
      },
      errors: {},
      deleteModal: { show: false, geoObject: null },
    }
  }

  handleFieldChange = (field) => (value) => {
    const newData = { ...this.state.data }
    const newErrors = { ...this.state.errors }
    delete newErrors[field]
    newData[field] = value
    this.setState({ data: newData, errors: newErrors })
  }

  validate = () => {
    const data = { ...this.state.data }
    const errors = {}
    if (!data.locales[DEFAULT_LOCALE].name) {
      errors[`locales.${DEFAULT_LOCALE}.name`] = 'Заполните название'
    }
    if (!data.locales[DEFAULT_LOCALE].description) {
      errors[`locales.${DEFAULT_LOCALE}.description`] = 'Заполните описание'
    }
    this.setState({ errors })
    return !Object.keys(errors).length
  }

  deleteUnusedFiles = async () => {
    let { data } = this.state
    let { initialData } = this.props
    if (!initialData) return
    if ((initialData.model !== null) && (data.model === null)) {
      await fetchAPI(`/in/globe3d/files/delete`, 'POST', { fileUrl: initialData.model.url })
    }
    if ((initialData.model_ios !== null) && (data.model_ios === null)) {
      await fetchAPI(`/in/globe3d/files/delete`, 'POST', { fileUrl: initialData.model_ios.url })
    }
    let initialImages = new Set(initialData.images.map(image => image.url))
    let newImages = new Set(data.images.map(image => image.url))
    for (let image of initialImages) {
      if (!newImages.has(image)) {
        await fetchAPI(`/in/globe3d/images/delete`, 'POST', { imageUrl: image })
      }
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    if (this.validate()) {
      await this.deleteUnusedFiles()
      this.props.onSubmit(this.state.data)
    }
  }

  showDeleteModal = (geoObject) => {
    this.setState({ deleteModal: { show: true, geoObject } })
  }
  hideDeleteModal = () => {
    this.setState({ deleteModal: { show: false, geoObject: null } })
  }
  handleObjectDelete = () => {
    const { geoCategoryId, initialData } = this.props
    this.hideDeleteModal()
    this.props.history.push(`/${geoCategoryId}/objects/`)
    this.props.onDelete(geoCategoryId, initialData.id)
  }

  render() {
    const { initialData } = this.props
    const { data, errors, deleteModal } = this.state
    return (
      <AbsoluteDiv style={{ padding: '0 15px' }}>
        <h3>
          {initialData ? 'Обновление' : 'Создание'} объекта
          <Button
            basic color='green' icon='save' size='mini'
            content='Сохранить'
            floated='right'
            onClick={this.handleSubmit}
          />
          {initialData ?
            <Button
              basic color='red' icon='trash' size='mini' floated='right'
              content='Удалить объект'
              onClick={() => this.showDeleteModal(initialData)}
            /> : null}
        </h3>
        <AbsoluteDiv top='38px' scrollable style={{ padding: '0 15px' }}>
          <Form onSubmit={this.handleSubmit}>
            <CommonField
              field={{
                label: 'Координаты',
                input: CoordinatesField,
                inputProps: {
                  ref: this.coordinatesField,
                },
              }}
              value={data.coordinates}
              onChange={this.handleFieldChange('coordinates')}
              error={errors['coordinates']}
            />
            <CountriesDropdown
              name={'country'}
              value={data.country}
              onChange={this.handleFieldChange('country')}
            />
            <CommonField
              field={{
                label: `Название (${DEFAULT_LOCALE})`,
                input: InputField,
              }}
              value={data.locales[DEFAULT_LOCALE].name}
              onChange={(value) => {
                let locales = { ...data.locales }
                locales[DEFAULT_LOCALE].name = value
                this.handleFieldChange('locales')(locales)
                const errors = { ...this.state.errors }
                delete errors[`locales.${DEFAULT_LOCALE}.name`]
                this.setState({ errors })
              }}
              error={errors[`locales.${DEFAULT_LOCALE}.name`]}
            />
            <CommonField
              field={{
                label: `Описание (${DEFAULT_LOCALE})`,
                input: TextAreaField,
              }}
              value={data.locales[DEFAULT_LOCALE].description}
              onChange={(value) => {
                let locales = { ...data.locales }
                locales[DEFAULT_LOCALE].description = value
                this.handleFieldChange('locales')(locales)
                const errors = { ...this.state.errors }
                delete errors[`locales.${DEFAULT_LOCALE}.description`]
                this.setState({ errors })
              }}
              error={errors[`locales.${DEFAULT_LOCALE}.description`]}
            />
            <CommonField
              field={{
                label: 'Дата публикации объекта',
                input: DatetimeField,
              }}
              value={data.available_since}
              onChange={this.handleFieldChange('available_since')}
              error={errors['available_since']}
            />
            <CommonField
              field={{
                label: 'Изображения',
                input: GeoObjectImagesField,
              }}
              value={data.images}
              onChange={this.handleFieldChange('images')}
              error={errors['images']}
            />
            <CommonField
              field={{
                label: 'Модель',
                input: FileField,
              }}
              value={data.model}
              onChange={this.handleFieldChange('model')}
              error={errors['model']}
            />
            <CommonField
              field={{
                label: 'Модель для iOS',
                input: FileField,
              }}
              value={data.model_ios}
              onChange={this.handleFieldChange('model_ios')}
              error={errors['model_ios']}
            />
            <CommonField
              field={{
                label: 'Локализация',
                input: LocalizationField,
                inputProps: {
                  localeForm: GeoObjectLocaleForm,
                },
              }}
              value={data.locales}
              onChange={this.handleFieldChange('locales')}
            />
          </Form>
        </AbsoluteDiv>
        {deleteModal.show ?
          <ObjectDeleteModal
            onDelete={this.handleObjectDelete}
            onCancel={this.hideDeleteModal}
            geoObject={deleteModal.geoObject}
          /> : null}
      </AbsoluteDiv>
    )
  }
}

export default withRouter(GeoObjectForm)